import CloseIcon from '@CS/assets/close.svg?component';
import CloseButtonStyle from './CloseButton.styles';

type CloseButtonProps = {
  onClick?: () => void;
};

export const CloseButton = ({ onClick }: CloseButtonProps) => (
  <CloseButtonStyle onClick={onClick}>
    <CloseIcon />
  </CloseButtonStyle>
);
